<div class="text-center" style="padding: 10px;">
    <h4>Select previous year to finish Tax Return</h4>
</div>
<div style="overflow-y: auto;" [className]="size.small ? 'row mobile-dialog-height' : 'row'">
    <div class="col-md-12">
        <table class="table table-striped table-bordered9 table-hover table-condensed stbl">
            <thead>
                <tr>
                    <th style="text-align: center">Year</th>
                    <th style="text-align: center">Description</th>
                    <th style="text-align: center">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of previousYears">
                    <td style="text-align: center; vertical-align: middle">
                        <span class="bold c-purple fs28">{{item.year}}</span>
                    </td>
                    <td style="text-align: center; vertical-align: middle">
                        <span class="bold c-grey fs16">{{item.name}}</span>
                    </td>
                    <td style="text-align: center; vertical-align: middle">
                        <button (click)="createYearFile(item.year)" class="btn btn-primary btn-sm"><i class="fas fa-check-circle"></i> Select</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>